export default function (state=null, action) {

	switch (action.type) {
		
	case 'FETCH_MOBILE_INFO_SUCCESS':
		return action.response

	case 'LOGOUT':
		return null
		
	default:
		return state
	
	}

}





// WEBPACK FOOTER //
// ./src/reducers/mobileInfo.js